import { ParcelShopAddress, PickupInStoreAddress } from '@accelerator/checkout/model/checkout.model';
import { ShippingInfoEventStore } from '@utils/gtm-tracking/events/trackAddShippingInfoEvent';

export const mapToStore = (
    store?: string | PickupInStoreAddress | ParcelShopAddress
): ShippingInfoEventStore | undefined => {
    if (!store) {
        return;
    }

    if (typeof store === 'string') {
        return {
            store_id: '',
            store_name: store
        };
    }

    return {
        store_id: store.id,
        store_name: 'storeName' in store ? store.storeName : store.companyName
    };
};
